﻿import { useState, useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { SaveBeneficiaryRequest, SendBeneMailing } from '../../../../../api/beneficiary';
import { TitledCircularProgress } from '../../feedback/TitledCircularProgress/TitledCircularProgress';
import { Alert } from '@mui/material';

const ConfirmBeneSent = (props) => {
  const [data, setData] = useState(JSON.parse(window.sessionStorage.getItem('currentBene')));

  const saveMutation = useMutation({
    mutationFn: async (data) => await SaveBeneficiaryRequest(data)(),
  });

  const sendMailMutation = useMutation({
    mutationFn: async (data) => await SendBeneMailing(data)(),
  });

  // Handle success for both mutations
  useEffect(() => {
    if (saveMutation.isSuccess || sendMailMutation.isSuccess) {
      successful();
    }
  }, [saveMutation.isSuccess, sendMailMutation.isSuccess]);

  const completeHandlerLocal = () => {
    // Execute save routine
    if ((data && data.hasIrrevocableBene) || (data && data.hasPOA)) {
      sendMailMutation.mutate(data);
      window.sessionStorage.setItem('currentBene', null);
      props.completedHandler();
    } else {
      saveMutation.mutate(data);
    }
  };

  const successful = () => {
    window.sessionStorage.setItem('currentBene', null);
    props.completedHandler();
  };

  const renderAlert = () => {
    if ((data && data.hasIrrevocableBene) || data.hasPOA) {
      return (
        <Alert severity="warning">
          No DocuSign packet was sent. The form will be mailed to the Owner's address and should be
          received within 5 - 10 business days.
        </Alert>
      );
    } else {
      return (
        <Alert severity="success">
          A DocuSign packet will be sent to the email addresses provided. Once all parties have
          completed the DocuSign packet the information will be updated in your records.
        </Alert>
      );
    }
  };

  const isLoading = saveMutation.isPending || sendMailMutation.isPending;
  const isError = saveMutation.isError || sendMailMutation.isError;

  return (
    <>
      {renderAlert()}
      {isLoading && <TitledCircularProgress title="" />}
      {!isLoading && <WizardButtons {...props} completedHandler={completeHandlerLocal} />}
      {isError && (
        <Alert severity="error">
          There was an issue processing the DocuSign request. Please report this to IT. Please
          include the time of the request.
        </Alert>
      )}
    </>
  );
};

export { ConfirmBeneSent };
